import React, { useEffect, useState } from "react";
import { Check, Copy } from "lucide-react";

/**
 * SOUND-776 — copy a link to the clipboard, with a visible result. Used for the
 * Kurv MERCHANT link (the one a merchant uses to review and sign), which we do
 * not open ourselves — the agent link is the one ops opens.
 *
 * Renders nothing without a url. A clipboard refusal (insecure context,
 * permissions) says so rather than pretending to have copied.
 */
export default function CopyLinkButton({ url, label = "Copy merchant link", className = "" }) {
  const [state, setState] = useState("idle"); // idle | copied | failed

  useEffect(() => {
    if (state === "idle") return undefined;
    const t = setTimeout(() => setState("idle"), 2000);
    return () => clearTimeout(t);
  }, [state]);

  if (!url) return null;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setState("copied");
    } catch {
      setState("failed");
    }
  };

  return (
    <button
      type="button"
      className={`btn btn-ghost justify-center gap-2 ${className}`}
      onClick={copy}
      title={url}
    >
      {state === "copied" ? <Check className="h-4 w-4 text-success" /> : <Copy className="h-4 w-4" />}
      {state === "copied" ? "Copied" : state === "failed" ? "Copy failed — select it from the tooltip" : label}
    </button>
  );
}
